import React from 'react';
const LoadingSpinner = ({ statusMessage }) => (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "loading-spinner multi" }),
    React.createElement("div", { className: "loading-spinner-content" }, statusMessage || 'Generating your answer')));
export default LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map